import { useLocation } from 'react-router-dom';

import { usePublicOrgInfoQuery } from 'src/shared/graphql/generated';
import { isServer } from 'src/shared/helpers/environment';
import { useIsEmbed } from 'src/shared/hooks';

export const useViewSampleImageEmbed = () => {
  const { search } = useLocation();
  const affOrgId = new URLSearchParams(search).get('aff_org_id');
  const leadFormConfigId = new URLSearchParams(search).get('leadFormConfigId');

  const isEmbed = useIsEmbed();

  // Will be used for feature accesses
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, loading } = usePublicOrgInfoQuery({
    variables: {
      publicIdentifier: affOrgId || '',
    },
    skip: !affOrgId,
  });

  const isLoading = isServer() || loading;

  const canViewSampleImageEmbed = isEmbed; // TODO: will also require feature accesses

  return { canViewSampleImageEmbed, isLoading, leadFormConfigId };
};
